import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import ArrowRightIcon from 'components/icons/arrow-right';

import { Label, TextWithArrowButtonRoot } from './text-with-arrow-button.styled';
import { TextWithArrowButtonProps } from './types';

const TextWithArrowButton: FC<TextWithArrowButtonProps> = ({
  onClick,
  messageId,
  withBorder = false,
  'data-testid': dataTestId,
}) => {
  const { formatMessage } = useIntl();

  return (
    <TextWithArrowButtonRoot data-testid={dataTestId} onClick={onClick} withBorder={withBorder}>
      <Label>{formatMessage({ id: messageId })}</Label>
      <ArrowRightIcon height="0.9rem" width="1rem" fill="#323232" />
    </TextWithArrowButtonRoot>
  );
};

export default TextWithArrowButton;
